import { z } from 'zod';
import { S3ObjectNotFoundError } from 'libs/end-to-end/src/types/errors/s3-object-not-found-error';
import { S3StorageCopyError } from 'libs/end-to-end/src/types/errors/s3-storage-copy-error';
import { S3StorageDeleteError } from 'libs/end-to-end/src/types/errors/s3-storage-delete-error';
import { S3StorageDownloadError } from 'libs/end-to-end/src/types/errors/s3-storage-download-error';
import { S3StorageSignDownloadUrlError } from 'libs/end-to-end/src/types/errors/s3-storage-sign-download-url-error';
import { S3StorageSignUploadUrlError } from 'libs/end-to-end/src/types/errors/s3-storage-sign-upload-url-error';
import { S3StorageUnavailableError } from 'libs/end-to-end/src/types/errors/s3-storage-unavailable-error';
import { S3StorageUploadError } from 'libs/end-to-end/src/types/errors/s3-storage-upload-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { S3StorageHeadError } from 'libs/end-to-end/src/types/errors/s3-storage-head-error';
import { S3StorageCopyDirectoryError } from 'libs/end-to-end/src/types/errors/s3-storage-copy-directory-error';
import { S3StorageSlowDownError } from 'libs/end-to-end/src/types/errors/s3-storage-slow-down-error';
import { S3StorageListObjectsV2Error } from 'libs/end-to-end/src/types/errors/s3-storage-list-objects-v2-error';
import { S3StorageSignMultiFileUploadUrlError } from 'libs/end-to-end/src/types/errors/s3-storage-sign-multi-file-upload-url-error';

export const S3StorageError = z.union([
  S3ObjectNotFoundError,
  S3StorageUnavailableError,
  S3StorageDownloadError,
  S3StorageUploadError,
  S3StorageDeleteError,
  S3StorageSignUploadUrlError,
  S3StorageSignMultiFileUploadUrlError,
  S3StorageSignDownloadUrlError,
  S3StorageCopyError,
  S3StorageHeadError,
  S3StorageCopyDirectoryError,
  S3StorageSlowDownError,
  S3StorageListObjectsV2Error,
  UnknownError,
]);

export type S3StorageError = z.infer<typeof S3StorageError>;
